/* sangria-blog-v3.css */
const amplifyURL = "https://asayaprod-prodin.sangria.tech";

// Added Script for UTM addition
window.onload = function () {
  var baseDomain = window.location.hostname;
  var referrerURL = document.referrer;
  var originalURL = window.location.href.split("?")[0];
  var utmParams =
    "?utm_medium=sangria&utm_source=sangria_blogs&utm_campaign=sangria_organic";

  function appendUTM(url, params) {
    return url + params;
  }

  function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  var updatedURL;
  if (!referrerURL || referrerURL === "" || !referrerURL.includes(baseDomain)) {
    // Append UTM parameters to the URL
    updatedURL = appendUTM(originalURL, utmParams);
    window.history.replaceState(null, "", updatedURL);
    console.log("Updated URL with UTM parameters:", updatedURL);

    // Set UTM cookies
    setCookie("utm_medium", "sangria", 30);
    setCookie("utm_source", "sangria_blogs", 30);
    setCookie("utm_campaign", "sangria_organic", 30);

    console.log("UTM cookies set: utm_medium, utm_source, utm_campaign");
  } else {
    updatedURL = originalURL;
    console.log("URL not updated (same domain as referrer):", updatedURL);
  }
};
document.addEventListener("DOMContentLoaded", async () => {
  await loadProductCards();
  await loadShopifyCart();
});

/* =========================================================
   GTM EVENT HELPER
========================================================= */
function sendGTMEvent({ event, eventModel }) {
  if (typeof window === "undefined") return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    ...eventModel,
  });
}

/* =========================================================
   PDP CLICK TRACKING (Minimal Version)
========================================================= */
document.addEventListener("click", function (e) {
  const link = e.target.closest("#sg-shoppable-product-url");
  if (!link) return;

  const card = link.closest("#sg-shoppable-product-card");
  if (!card) return;

  const title = card
    .querySelector("#sg-shoppable-product-title")
    ?.textContent?.trim();

  const url = link.href;

  sendGTMEvent({
    event: "pdp_click",
    eventModel: {
      event_label: url,
      event_title: title,
    },
  });
});


async function loadProductCards(retry = false) {
  try {
    // SSR safety
    if (typeof window === "undefined") return;

    const slug = window.location.pathname
      .split("/")
      .filter(Boolean)
      .pop();

    if (!slug) return;

    const searchInput = document.getElementById(
      "sg-isShoppableCollectionValue"
    );
    const searchValue = searchInput?.value?.trim() || "";

    const baseUrl = `${amplifyURL}/blogs/shopifyplp/${slug}`;
    const url = searchValue
      ? `${baseUrl}?collectionId=${encodeURIComponent(searchValue)}`
      : baseUrl;

    const response = await fetch(url, {
      method: "GET",
      headers: { Accept: "text/html" },
      cache: "no-store",
    });

    if (!response.ok) {
      throw new Error(`HTTP error ${response.status}`);
    }

    const html = await response.text();

    // 🧠 Parse in isolated DOM
    const tempContainer = document.createElement("div");
    tempContainer.innerHTML = html;

    // 🎯 Extract ONLY engagement section
    const engagementSection = tempContainer.querySelector(
      "#sg-engagement-section"
    );

    if (!engagementSection) {
      if (!retry) {
        console.warn("Engagement section not found. Retrying...");
        setTimeout(() => loadProductCards(true), 500);
        return;
      }
      throw new Error("sg-engagement-section missing");
    }

    // 🧹 REMOVE all dangerous tags
    engagementSection
      .querySelectorAll(
        "script, link, style, template, noscript, iframe"
      )
      .forEach((el) => el.remove());

    // 🧹 Remove Next.js attributes & hydration junk
    engagementSection
      .querySelectorAll("[data-nscript], [id^='__next'], [id^='__NEXT']")
      .forEach((el) => el.remove());

    const container = document.getElementById(
      "sg-isShoppablePlpContainer"
    );

    if (!container) return;

    // Clear previous content
    container.innerHTML = "";

    // ✅ Append ONLY safe content
    const safeClone = engagementSection.cloneNode(true);
    container.appendChild(safeClone);

    // 🎯 Initialize logic only on cloned cards
    safeClone
      .querySelectorAll("#sg-shoppable-product-card")
      .forEach((card) => {
        initializeVariantHandling(card);
      });

    attachEventListeners();
  } catch (err) {
    console.error("❌ Product card load failed:", err);
  }
}


function initializeVariantHandling(card) {
  // Early exit if card is invalid
  if (!card) return;

  // Cache all DOM elements at once
  const elements = {
    variantContainer: card.querySelector("#sg-shoppable-variant-selector"),
    hiddenInputJson: card.querySelector("#sg-shop-variant-id-values"),
    hiddenInput: card.querySelector("#variant-id-input"),
    salePrice: card.querySelector("#sg-shoppable-regular-price"),
    salePriceEl: card.querySelector("#sg-shoppable-sale-price"),
    addToCartButton: card.querySelector("#sg-shoppable-add-to-cart-button"),
    addToCartLabel: card.querySelector("#sg-add-to-cart-label"),
      productImage: card.querySelector("#sg-shoppable-product-image"),
  };

  // Validate required elements
  if (
    !elements.variantContainer ||
    !elements.hiddenInputJson ||
    !elements.hiddenInput ||
    !elements.salePrice
  ) {
    return;
  }

  const selects = elements.variantContainer.querySelectorAll("select");
  if (selects.length === 0) return;

  // Parse variants once and build lookup map
  let variants = [];
  let variantMap = new Map();
  let formatter = null;

  try {
    const jsonString = elements.hiddenInputJson.value.replace(/&quot;/g, '"');
    variants = JSON.parse(jsonString);

    // Create price formatter once
    const currency = variants[0]?.currencyCode || "INR";
    formatter = new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });

    // Build variant lookup map for O(1) access
    variants.forEach((variant) => {
      if (!variant.productAttributes) return;

      const attrValues = Object.values(variant.productAttributes)
        .filter((val) => val?.trim())
        .map((val) => val.trim().toLowerCase())
        .sort()
        .join("|");

      if (attrValues) {
        variantMap.set(attrValues, variant);
      }
    });
  } catch (error) {
    console.error("Variant initialization error:", error);
    return;
  }

  // Cache button classes for performance
  const buttonClasses = {
    enabled: ["bg-black", "hover:bg-gray-800"],
    disabled: ["opacity-50", "cursor-not-allowed", "bg-gray-400"],
  };

  // Fast variant lookup function
  function findVariant() {
    const selectedValues = [];
    for (let i = 0; i < selects.length; i++) {
      const value = selects[i].value?.trim();
      if (value) {
        selectedValues.push(value.toLowerCase());
      }
    }

    if (selectedValues.length === 0) return null;

    const key = selectedValues.sort().join("|");
    return variantMap.get(key) || null;
  }

  // Optimized price update function
  function updatePricing(variant) {
    const { salePrice, salePriceEl } = elements;

    // Reset prices first
    salePrice.textContent = "";
    if (salePriceEl) {
      salePriceEl.textContent = "";
      salePriceEl.style.display = "none";
    }

    if (!variant) return;

    const regularPrice = parseFloat(variant.price) || 0;
    const discountPrice = parseFloat(variant.salePrice) || 0;

    if (discountPrice > 0 && discountPrice < regularPrice) {
      // Show sale price
      salePrice.textContent = formatter.format(discountPrice);
      if (salePriceEl) {
        salePriceEl.textContent = formatter.format(regularPrice);
        salePriceEl.style.display = "inline";
      }
    } else if (regularPrice > 0) {
      // Show regular price only
      salePrice.textContent = formatter.format(regularPrice);
    } else if (discountPrice > 0) {
      // Fallback to discount price
      salePrice.textContent = formatter.format(discountPrice);
    }
  }
  function updateImage(variant) {
  if (!variant || !elements.productImage) return;

  const imageUrl = variant?.featuredImage?.[0]?.src;

  if (imageUrl) {
    elements.productImage.src = imageUrl;
    elements.productImage.alt =
      variant?.featuredImage?.[0]?.alt_text || variant.title;
  }
}

  // Optimized button state update
  function updateButtonState(variant) {
    const { addToCartButton, addToCartLabel } = elements;
    if (!addToCartButton || !addToCartLabel) return;

    const hasStock = variant && (parseInt(variant.inventoryQuantity) || 0) > 0;

    if (hasStock) {
      addToCartButton.disabled = false;
      addToCartButton.classList.remove(...buttonClasses.disabled);
      addToCartButton.classList.add(...buttonClasses.enabled);
      addToCartLabel.textContent = "Add To Cart";
    } else {
      addToCartButton.disabled = true;
      addToCartButton.classList.add(...buttonClasses.disabled);
      addToCartButton.classList.remove(...buttonClasses.enabled);
      addToCartLabel.textContent = variant ? "Out of Stock" : "Select Variant";
    }
  }

  // Main update function
  function updateVariantDetails() {
    const variant = findVariant();

    // Update hidden input
    elements.hiddenInput.value = variant?.productAttributeId || "";

    // Update UI in batch
    requestAnimationFrame(() => {
      updatePricing(variant);
      updateButtonState(variant);
      updateImage(variant);
    });
  }

  // Debounced update function
  let updateTimeout;
  function debouncedUpdate() {
    clearTimeout(updateTimeout);
    updateTimeout = setTimeout(updateVariantDetails, 50);
  }

  // Bind events efficiently
  for (let i = 0; i < selects.length; i++) {
    selects[i].addEventListener("change", debouncedUpdate, { passive: true });
  }

  // Initial update
  updateVariantDetails();

  // Return cleanup function
  return function cleanup() {
    clearTimeout(updateTimeout);
    for (let i = 0; i < selects.length; i++) {
      selects[i].removeEventListener("change", debouncedUpdate);
    }
  };
}

async function loadDynamicScripts(container) {
  container.querySelectorAll("script").forEach((script) => {
    const newScript = document.createElement("script");
    if (script.src) {
      newScript.src = script.src;
    } else {
      newScript.textContent = script.textContent;
    }
    document.body.appendChild(newScript);
  });
}

let cartItems = [];
let cartTotal = 0;

async function loadShopifyCart() {
  try {
    const response = await fetch("/cart.js");
    const data = await response.json();

    cartItems = data.items.map((item) => ({
      id: item.variant_id.toString(),
      title: item.product_title,
      price: parseFloat(formatPrice(item.original_price)),
      image: item.image,
      quantity: item.quantity,
      variantAttributes: Object.fromEntries(
        item.options_with_values.map((opt) => [
          opt.name.toLowerCase(),
          opt.value,
        ])
      ),
    }));

    updateCartUI();
  } catch (error) {
    console.error("Error loading Shopify cart:", error);
  }
}

function formatPrice(cents) {
  return (cents / 100).toFixed(2);
}

function customEvent(action, event_label = "", event_title = "", value = 0) {
  gtag("event", action, {
    event_label: event_label,
    event_title: event_title,
    value: value,
  });
  console.log("Custom event triggered:", {
    action,
    event_label,
    event_title,
    value,
  });
}

function handleClickEvents(action, event_title, label = "") {
  console.log("Inside handleClickEvents");
  const from = window.location.href;
  let event_label = "";
  if (label != "") {
    event_label = label;
  } else if (from.includes("/blogs")) {
    event_label = "Blog";
  } else if (from.includes("/pages")) {
    event_label = "PLP";
  }
  customEvent(action, event_label, event_title);
}

async function addToCart(product) {
  try {
    handleClickEvents("sangria_addtocart", "Add to cart", "PLP");
    const payload = {
      items: [
        {
          id: product.id,
          quantity: product.quantity || 1,
        },
      ],
    };

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) throw new Error("Failed to add product to Shopify cart");

    const existing = cartItems.find((item) => item.id === product.id);
    if (existing) {
      existing.quantity += 1;
    } else {
      cartItems.push({
        id: product.id,
        title: product.title,
        price: parseFloat(product.price),
        image: product.image,
        quantity: product.quantity || 1,
        variantAttributes: product?.variantAttributes || {},
      });
    }

    updateCartUI();
    openCartDrawer();
  } catch (error) {
    console.error("Error adding to Shopify cart:", error);
  }
}

function updateCartUI() {
  const container = document.getElementById("sg-cart-items");
  const subtotal = document.getElementById("sg-cart-subtotal");

  if (container) {
    container.innerHTML = cartItems.length
      ? ""
      : '<p class="text-center py-8 text-gray-500">Your cart is empty</p>';
    console.log(cartItems, "cartItems");
    cartItems.forEach((item) => {
      const el = document.createElement("div");
      el.className = "cart-item";
      console.log(item, "item");
      // Generate attribute lines dynamically (e.g., size, color, etc.)
      const attributeHtml = Object.entries(item?.variantAttributes || {})
        .map(
          ([key, value]) =>
            `<p class="text-sm text-gray-700 mt-1 mb-0">${
              key.charAt(0).toUpperCase() + key.slice(1)
            }: ${value}</p>`
        )
        .join("");
      el.innerHTML = `
          <img src="${item.image}" alt="${item.title}" class="cart-item-image">
          <div class="flex flex-col justify-evenly flex-grow m-4">
            <h4 class="font-medium flex-shrink-0">${item.title}</h4>
             ${attributeHtml}

        <span class="">$${item.price.toFixed(2)} </span>
            <div class="flex justify-between items-center">
              <div class="flex items-center border rounded">
                <button class="px-6 py-1 decrease-quantity cursor-pointer" data-id="${
                  item.id
                }">-</button>
                <span class="px-2">${item.quantity}</span>
                <button class="px-6 py-1 increase-quantity cursor-pointer" data-id="${
                  item.id
                }">+</button>
              </div>
              <button class="ml-2 remove-item cursor-pointer" data-id="${
                item.id
              }">🗑️</button>
            </div>
          </div>
        `;
      container.appendChild(el);
    });

    container.querySelectorAll(".increase-quantity").forEach((btn) =>
      btn.addEventListener("click", () => {
        const item = cartItems.find((i) => i.id === btn.dataset.id);
        if (item) item.quantity += 1;
        updateCartUI();
      })
    );

    container.querySelectorAll(".decrease-quantity").forEach((btn) =>
      btn.addEventListener("click", () => {
        const item = cartItems.find((i) => i.id === btn.dataset.id);
        if (item && item.quantity > 1) item.quantity -= 1;
        updateCartUI();
      })
    );

    container.querySelectorAll(".remove-item").forEach((btn) =>
      btn.addEventListener("click", async () => {
        const id = btn.dataset.id;

        try {
          await fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              id,
              quantity: 0,
            }),
          });

          cartItems = cartItems.filter((i) => i.id !== id);
          updateCartUI();
        } catch (error) {
          console.error("Failed to remove item from cart:", error);
        }
      })
    );
  }

  if (subtotal) {
    cartTotal = cartItems.reduce((sum, i) => sum + i.price * i.quantity, 0);
    subtotal.textContent = `$${cartTotal.toFixed(2)} USD`;
  }
}

function attachEventListeners() {
  document
    .querySelectorAll("#sg-shoppable-add-to-cart-button")
    .forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const card = btn.closest("#sg-shoppable-product-card");
        const sizeSelect = card.querySelector(
          "#sg-shoppable-size-selector"
        )?.value;
        const colorSelect = card.querySelector(
          "#sg-shoppable-color-selector"
        )?.value;
        const title = card
          .querySelector("#sg-shoppable-product-title")
          ?.textContent?.trim();
        const price = card
          .querySelector("#sg-shoppable-regular-price")
          ?.textContent?.trim()
          ?.replace(/[^\d.]/g, "");
        const image = card.querySelector("#sg-shoppable-product-image")?.src;
        const id = card.querySelector('input[name="id"]')?.value;

        const variantAttributes = {};
        const variantSelector = card.querySelector(
          "#sg-shoppable-variant-selector"
        );

        if (variantSelector) {
          const selects = variantSelector.querySelectorAll("select");
          selects.forEach((select) => {
            const attrKey =
              select.getAttribute("data-attr-key") || // ✅ This now returns the correct key like "size"
              select.getAttribute("name") ||
              select.getAttribute("id")?.replace("sg-shoppable-", "") ||
              `attribute-${Math.random()}`;

            variantAttributes[attrKey] = select.value;
          });
        }

        console.log("Final variantAttributes:", variantAttributes);

        // ✅ Show selected variant values (also covers defaults on first click)
        console.log("Selected Variant Attributes:", variantAttributes);

        if (id && title && price && image) {
          console.log("Variant Attributes:", variantAttributes);
          console.log("test 7");
          addToCart({
            id,
            title,
            price,
            image,
            quantity: 1,
            variantAttributes,
          });
        }
      });
    });

  document.querySelectorAll("#sg-zoom-toggle").forEach((btn) => {
    btn.addEventListener("click", () => {
      const wrapper = btn.closest("#sg-shoppable-image-wrapper");
      if (!wrapper) return;
      wrapper.classList.toggle("zoomed");

      const productCard = btn.closest('[id^="sg-shoppable-product-card-"]');
      if (productCard) {
        productCard.classList.toggle("zoomed");
      }

      const icon = btn.querySelector("svg");
      const zoomIn = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" class="lucide lucide-zoom-in w-5 h-5 text-gray-600"><circle cx="11" cy="11" r="8"></circle><line x1="21" x2="16.65" y1="21" y2="16.65"></line><line x1="11" x2="11" y1="8" y2="14"></line><line x1="8" x2="14" y1="11" y2="11"></line></svg>`;
      const zoomOut = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" class="lucide lucide-zoom-in w-5 h-5 text-gray-600"><circle cx="11" cy="11" r="8"></circle><line x1="21" x2="16.65" y1="21" y2="16.65"></line><line x1="8" x2="14" y1="11" y2="11"></line></svg>`;
      icon.outerHTML = wrapper.classList.contains("zoomed") ? zoomOut : zoomIn;
    });
  });

  const closeBtn = document.getElementById("sg-close-cart");
  if (closeBtn) closeBtn.addEventListener("click", closeCartDrawer);

  const overlay = document.getElementById("sg-cart-overlay");
  if (overlay) {
    overlay.addEventListener("click", closeCartDrawer); // 🆕 Added to close cart when clicking outside
  }
}

function openCartDrawer() {
  console.log("open cart");
  document.getElementById("sg-cart-drawer")?.classList.add("open");
  document.getElementById("sg-cart-overlay")?.classList.add("open");
  document.body.classList.add("drawer-open");
}

function closeCartDrawer() {
  document.getElementById("sg-cart-drawer")?.classList.remove("open");
  document.getElementById("sg-cart-overlay")?.classList.remove("open");
  document.body.classList.remove("drawer-open");
}
document.addEventListener("click", async (event) => {
  const viewBtn = event.target.closest("#sg-view-button");
  if (!viewBtn) return;

  event.preventDefault();

  const modal = document.getElementById("sg-quick-view-modal");
  const content = document.getElementById("sg-quick-view-content");
  content.innerHTML = "Loading...";

  const card = viewBtn.closest("[id^='sg-shoppable-product-card']");
  if (!card) return;

  try {
    // Extract product info
    let image = card.querySelector("#sg-shoppable-product-image")?.src;
    const title = card.querySelector(
      "#sg-shoppable-product-title"
    )?.textContent;
    const price = card.querySelector(
      "#sg-shoppable-regular-price"
    )?.textContent;
    const salePrice = card.querySelector(
      "#sg-shoppable-sale-price"
    )?.textContent;
    const variantId = card.querySelector("#variant-id-input")?.value;
    const desc = card.querySelector("#sg-hidden-description")?.value;
    const productUrl = card.querySelector("#sg-shoppable-product-url")?.href;

    const variantWrapper = card.querySelector("#sg-shoppable-variant-selector");
    const variantSelects = variantWrapper?.querySelectorAll("select") || [];
    const variants = JSON.parse(
      card
        .querySelector("#sg-shop-variant-id-values")
        ?.value.replace(/&quot;/g, '"') || "[]"
    );

    // Clone selectors
    const clonedSelectors = [];
    const selectedAttributes = {};

    variantSelects.forEach((select, idx) => {
      const name = select.getAttribute("id") || `attr-${idx}`;
      const cloned = select.cloneNode(true);
      cloned.setAttribute("data-attr-name", name);
      selectedAttributes[name] = cloned.value;
      clonedSelectors.push(cloned);
    });

    // Helper function to check if price is valid and greater than 0
    const isValidPrice = (priceValue) => {
      if (!priceValue || priceValue === "undefined") return false;
      const numericPrice = parseFloat(
        priceValue.toString().replace(/[^\d.]/g, "")
      );
      return !isNaN(numericPrice) && numericPrice > 0;
    };

    // Helper function to render sale price element
    const renderSalePriceElement = (salePrice) => {
      return isValidPrice(salePrice)
        ? `<p id="sg-shoppable-quick-price" class="ml-2 text-lg line-through">${salePrice}</p>`
        : "";
    };

    // Render content
    content.innerHTML = `
      <div class="w-full md:w-1/2 flex justify-center items-center">
        <img id="quick-view-image" src="${image}" alt="${title}" class="rounded-xl w-full object-cover max-h-[450px]" />
      </div>
      <div class="w-full md:w-1/2 flex flex-col gap-4">
        <a id="sg-shoppable-product-url" target="_blank" rel="noopener noreferrer" class="block" href="${productUrl}">
          <h2 class="text-2xl font-bold">${title}</h2>
        </a>
        <div class="flex gap-2 item-center">
          <p id="quick-price" class="text-lg font-semibold">${price}</p>
          ${renderSalePriceElement(salePrice)}
        </div>
        ${
          desc
            ? `<div class="text-xl h-[200px] overflow-y-auto">${desc}</div>`
            : ""
        }
        <label class="block font-medium">Choose options:</label>
        <div id="sg-quick-variant-wrapper" class="space-y-3"></div>
        <div class="flex items-center gap-4 mt-2">
          <label class="font-medium">Qty:</label>
          <div class="flex border rounded w-[100px] overflow-hidden">
            <button class="flex-1 py-1 text-lg font-bold cursor-pointer" id="quick-qty-decrease">−</button>
            <input id="quick-qty" type="number" min="1" value="1" class="w-10 text-center border-l border-r" />
            <button class="flex-1 py-1 text-lg font-bold cursor-pointer" id="quick-qty-increase">+</button>
          </div>
        </div>
        <input type="hidden" name="id" value="${variantId}" id="quick-variant-id-input">
        <button id="sg-quick-add-to-cart" class="mt-4 bg-black text-white py-2 px-4 rounded hover:bg-gray-800 flex justify-center gap-2 items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shopping-bag">
            <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" />
            <path d="M3 6h18" />
            <path d="M16 10a4 4 0 0 1-8 0" />
          </svg>
          Add To Cart
        </button>
      </div>
    `;

    // Append cloned selects
    const wrapper = document.getElementById("sg-quick-variant-wrapper");
    clonedSelectors.forEach((cloned) => wrapper.appendChild(cloned));

    // Handle variant update
    function updateQuickVariant() {
      clonedSelectors.forEach((sel) => {
        const attr = sel.getAttribute("data-attr-name");
        selectedAttributes[attr] = sel.value;
      });

      const matched = variants.find((variant) => {
        const attrValues = Object.values(variant.productAttributes || {});
        return Object.values(selectedAttributes).every((val) =>
          attrValues.includes(val)
        );
      });

      if (matched) {
        const hasStock = parseInt(matched.inventoryQuantity || "0") > 0;
        document.getElementById("quick-variant-id-input").value =
          matched.productAttributeId;

        const quickViewImage =
          document.getElementById("quick-view-image");

        const imageUrl =
          matched?.featuredImage?.[0]?.src;

        if (quickViewImage && imageUrl) {
          quickViewImage.src = imageUrl;

        // keep add-to-cart image synced
        image = imageUrl;
        }

        console.log(matched.salePrice, "matched.salePrice");

        // Helper function to safely parse price
        const parsePrice = (price) => {
          if (
            price === null ||
            price === undefined ||
            price === "undefined" ||
            price === ""
          ) {
            return 0;
          }
          const parsed = parseFloat(price.toString().replace(/[^\d.]/g, ""));
          return isNaN(parsed) ? 0 : parsed;
        };

        const regular = parsePrice(matched.price);
        const sale = parsePrice(matched.salePrice);
        const currency = matched.currencyCode || "INR";

        // Update main price (show sale price if available and > 0, otherwise regular price)
        const mainPrice = sale > 0 ? sale : regular;
        document.getElementById("quick-price").textContent =
          new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency,
          }).format(mainPrice);

        // Handle sale price display
        const salePriceElement = document.getElementById(
          "sg-shoppable-quick-price"
        );
        if (sale > 0 && sale < regular) {
          // Show crossed-out regular price only if sale price exists and is less than regular
          if (!salePriceElement) {
            // Create sale price element if it doesn't exist
            const priceContainer =
              document.getElementById("quick-price").parentElement;
            const newSalePriceElement = document.createElement("p");
            newSalePriceElement.id = "sg-shoppable-quick-price";
            newSalePriceElement.className = "ml-2 text-lg line-through";
            priceContainer.appendChild(newSalePriceElement);
          }
          document.getElementById("sg-shoppable-quick-price").textContent =
            new Intl.NumberFormat("en-IN", {
              style: "currency",
              currency,
            }).format(regular);
          document.getElementById("sg-shoppable-quick-price").style.display =
            "block";
        } else {
          // Hide sale price element if no valid sale price
          if (salePriceElement) {
            salePriceElement.style.display = "none";
          }
        }

        const addToCartButton = document.getElementById("sg-quick-add-to-cart");
        if (hasStock) {
          addToCartButton.disabled = false;
          addToCartButton.classList.remove(
            "opacity-50",
            "cursor-not-allowed",
            "bg-gray-400"
          );
          addToCartButton.classList.add("bg-black", "hover:bg-gray-800");
        } else {
          addToCartButton.disabled = true;
          addToCartButton.classList.add(
            "opacity-50",
            "cursor-not-allowed",
            "bg-gray-400"
          );
          addToCartButton.classList.remove("bg-black", "hover:bg-gray-800");
        }
      }
    }

    // Init variant logic
    clonedSelectors.forEach((sel) =>
      sel.addEventListener("change", updateQuickVariant)
    );
    updateQuickVariant();

    // Quantity logic
    const qtyInput = document.getElementById("quick-qty");
    document
      .getElementById("quick-qty-increase")
      .addEventListener("click", () => {
        qtyInput.value = parseInt(qtyInput.value) + 1;
      });
    document
      .getElementById("quick-qty-decrease")
      .addEventListener("click", () => {
        if (parseInt(qtyInput.value) > 1)
          qtyInput.value = parseInt(qtyInput.value) - 1;
      });

    // Add to cart logic
    document
      .getElementById("sg-quick-add-to-cart")
      .addEventListener("click", () => {
        const id = document.getElementById("quick-variant-id-input").value;
        const qty = parseInt(qtyInput.value);
        if (!id || qty < 1) return;

        const variantAttributes = {};
        document
          .querySelectorAll("#sg-quick-variant-wrapper select")
          .forEach((select) => {
            const attrKey =
              select.getAttribute("data-attr-key") ||
              select.getAttribute("name") ||
              select.getAttribute("id")?.replace("sg-shoppable-", "") ||
              `attr-${Math.random()}`;
            variantAttributes[attrKey] = select.value;
          });

        console.log("variantAttributes", variantAttributes);

        addToCart({
          id,
          title,
          price: document
            .getElementById("quick-price")
            .textContent.replace(/[^\d.]/g, ""),
          image,
          quantity: qty,
          variantAttributes,
        });
      });

    // Show modal
    modal.style.display = "flex";
    modal.classList.remove("hidden");
  } catch (err) {
    console.error("Quick View error:", err);
    content.innerHTML = "<p>Error loading Quick View.</p>";
  }
});
// Close on backdrop or close button
document
  .getElementById("sg-quick-view-modal")
  .addEventListener("click", (event) => {
    const modal = event.currentTarget;
    const content = document.getElementById("sg-quick-view-content");
    const closeBtn = document.getElementById("sg-quick-view-close");

    if (event.target === modal || event.target === closeBtn) {
      modal.classList.add("hidden");
      modal.style.display = "none";
      content.innerHTML = "";
    }
  });

document.addEventListener("DOMContentLoaded", function () {
  // Close drawer on overlay click
  document
    .getElementById("sg-cart-overlay")
    ?.addEventListener("click", closeCartDrawer);

  // Also close on ✖ button click
  document
    .getElementById("sg-close-cart")
    ?.addEventListener("click", closeCartDrawer);
});

window.openCartDrawer = openCartDrawer;
window.closeCartDrawer = closeCartDrawer;
window.addToCart = addToCart;
